<template></template>
<script>
  import auth from '../auth'
  export default {
    created: function(){
        auth.logout(this)
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Logout.vue